module.exports = __webpack_public_path__ + "img/section1.73a1ad49.png";